<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="search-container min flex align-center justify-between">
            <div class="flex align-center">
                <el-select v-model="p_mid" clearable filterable placeholder="请选择申报负责人">
                    <el-option
                        v-for="item in members"
                        :key="item.mid"
                        :label="item.name"
                        :value="item.mid">
                    </el-option>
                </el-select>
                <el-select v-model="join_mid" class="margin-left-xs" clearable filterable placeholder="请选择辅助申报人员">
                    <el-option
                        v-for="item in members"
                        :key="item.mid"
                        :label="item.name"
                        :value="item.mid">
                    </el-option>
                </el-select>
                <el-input v-model="keyword" class="margin-left-xs" placeholder="请输入申报项目名称"></el-input>
                <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
            </div>
            <div class="flex align-center">
                <router-link to="/web/staff/project/remind">
                    <el-button class="btn min bg-ghost radius"><i class="el-icon-message-solid margin-right-xs"></i>提醒
                    </el-button>
                </router-link>
                <el-button class="btn max bg-orange radius margin-left-xs" type="warning" @click="addProjectApplyDialog = true">
                    <i class="el-icon-plus margin-right-xs"></i>申报项目
                </el-button>
                <el-button class="btn max bg-blue radius" type="primary" @click="chooseProjectApplyDialog = true">
                    <i class="el-icon-plus margin-right-xs"></i>关联项目
                </el-button>
            </div>
        </div>
        <div class="page-list flex flex-direction margin-top-sm">
            <el-table
                v-loading="loading"
                :data="lists"
                border
                header-row-class-name="table-header"
                style="width: 100%">
                <el-table-column label="年度" prop="create_time" width="80">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.create_time | year }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="申报项目名称" prop="p_name">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.p_name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="申报负责人" prop="p_mid" width="120">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.fuzeren_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="辅助申报人员" prop="p_mid" width="150">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.fuzeren_name_fu.join(',') || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="申报开始时间" prop="end_time" width="150">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.end_time || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="申报结束时间" prop="end_time" width="150">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.end_time || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="申报状态" prop="state" width="279">
                    <template slot-scope="scope">
                        <div class="table-item">
                            <div :class="scope.row.state | astatus_color">{{ scope.row.state | astatus }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="name" width="350">
                    <template slot-scope="scope">
                        <div class="table-operate text-center">
                            <el-button class="radius blue" size="small" type="primary" @click="toPage(`/web/staff/apply/add/${scope.row.p_id}`)">
                                申报信息
                            </el-button>
                            <el-button v-if="user.mrole === 1" class="radius red" size="small" type="primary" @click="delProject(scope.row)">
                                删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top self-end"
                layout="prev, pager, next"
                @current-change="init">
            </el-pagination>
        </div>
        <add-project-apply-dialog :dialog-visible="addProjectApplyDialog" @watchState="watchState"></add-project-apply-dialog>
        <choose-project-apply-dialog :dialog-visible="chooseProjectApplyDialog" @watchState="watchState"></choose-project-apply-dialog>
    </div>
</template>

<script>

import {delProject, getAllMember, getApplyProjectList} from "@/api";
import {confirm, filterDate, TOAST, toast, zhDate} from "@/utils/utils";
import {apply_status, apply_status_color, customColors} from "@/utils/const";
import AddProjectApplyDialog from "@/views/web/staff/page/apply/components/AddProjectApplyDialog";
import ChooseProjectApplyDialog from "@/views/web/staff/page/apply/components/ChooseProjectApplyDialog";

export default {
    name: "project-list",
    components: {ChooseProjectApplyDialog, AddProjectApplyDialog},
    data() {
        return {
            customColors: customColors,
            keyword: '',
            p_mid: '',
            join_mid: '',
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            members: [],
            addProjectApplyDialog: false,
            chooseProjectApplyDialog: false
        }
    },
    created() {
        this.$emit('setIndex', [1,6], '项目申报', false)
        this.getClassify()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async getClassify() {
            let _data = await getAllMember()
            this.members = _data.data
        },
        async init() {
            this.loading = true
            let _data = await getApplyProjectList(this.keyword, this.p_mid, this.join_mid, this.page, this.limit)
            this.loading = false
            _data.data.data.map(item => {
                item.end_time = filterDate(item.end_time)
            })
            this.lists = _data.data.data
            this.total = _data.data.total
        },
        search() {
            this.page = 1
            this.init()
        },
        toPage(path) {
            this.$router.push(path)
        },
        delProject(data) {
            confirm(`删除项目`, `你确定删除<b>${data.p_name}</b>项目吗？`, () => {
                this.delItem(data.p_id)
            }, '确认', true)
        },
        async delItem(id) {
            let _data = await delProject(id)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        watchState(data) {
            if (data) this.search()
            this.addProjectApplyDialog = false
            this.chooseProjectApplyDialog = false
        }
    },
    filters: {
        year(date) {
            return zhDate(date, 4)
        },
        astatus(status){
            // //0 1提交审核 2通过 -2拒绝 3提交审核 4通过-4拒绝
            // /   /   /  /
            return apply_status(status)
        },
        astatus_color(status){
            //"status": 0, //项目状态 0未提交审核 1已提交审核 2进行中 3驳回提交
            return apply_status_color(status)
        },
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .table-operate {
        .blue {
            background: #5576a0;
            border: none;

            &.disabled {
                background: #5576a033;
            }
        }

        .green {
            background: #4f9f8b;
            border: none;

            &.disabled {
                background: #4f9f8b33;
            }
        }

        .yellow {
            background: #b08e57;
            border: none;

            &.disabled {
                background: #b08e5733;
            }
        }

        .red {
            background: #f43f3b;
            border: none;

            &.disabled {
                background: #f43f3b33;
            }
        }
    }
}
</style>
